import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

/**
 * GET sng/lobby — list REGISTERING (and optionally RUNNING) Sit & Go tournaments
 */
export const getSngLobbyService = (params = {}) => {
  return axiosInstanceService(METHOD_TYPES.get, 'sng/lobby', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.page,
    params
  })
}

/**
 * POST sng/register — { tournamentId }
 */
export const registerSngService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'sng/register', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    showApiSuccessMessage: true
  })
}

/**
 * POST sng/unregister — { tournamentId }
 */
export const unregisterSngService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'sng/unregister', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    showApiSuccessMessage: true
  })
}

/**
 * POST sng/ready — confirm attendance during countdown { tournamentId?, tournamentTableId? }
 */
export const markSngReadyService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'sng/ready', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    showApiSuccessMessage: false
  })
}

/**
 * GET sng/leaderboard
 */
export const getSngLeaderboardService = (params = {}) => {
  return axiosInstanceService(METHOD_TYPES.get, 'sng/leaderboard', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.page,
    params
  })
}

/**
 * GET sng/my-stats
 */
export const getSngMyStatsService = (params = {}) => {
  return axiosInstanceService(METHOD_TYPES.get, 'sng/my-stats', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

/**
 * GET sng/:tournamentId/standings?tournamentTableId=
 * Table-scoped standings for continuous Sit & Go.
 */
export const getSngStandingsService = (tournamentId, params = {}) => {
  return axiosInstanceService(METHOD_TYPES.get, `sng/${tournamentId}/standings`, {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

/**
 * GET sng/:tournamentId/results?tournamentTableId=
 * Final standings / winners for the View Result screen.
 */
export const getSngResultsService = (tournamentId, params = {}) => {
  return axiosInstanceService(METHOD_TYPES.get, `sng/${tournamentId}/results`, {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

/**
 * GET sng/:tournamentId/tables
 */
export const getSngTournamentTablesService = (tournamentId) => {
  return axiosInstanceService(METHOD_TYPES.get, `sng/${tournamentId}/tables`, {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

/**
 * GET sng/:tournamentId/tables/:tournamentTableId
 */
export const getSngTournamentTableDetailService = (tournamentId, tournamentTableId) => {
  return axiosInstanceService(
    METHOD_TYPES.get,
    `sng/${tournamentId}/tables/${tournamentTableId}`,
    {},
    {
      server: microServices.SERVICE_URL_1,
      loader: LOADER_HANDLER_TYPES.table
    }
  )
}

/**
 * GET sng/:tournamentId/tables/:tournamentTableId/hands
 */
export const getSngTournamentHandsService = (tournamentId, tournamentTableId, params = {}) => {
  return axiosInstanceService(
    METHOD_TYPES.get,
    `sng/${tournamentId}/tables/${tournamentTableId}/hands`,
    {},
    {
      server: microServices.SERVICE_URL_1,
      loader: LOADER_HANDLER_TYPES.table,
      params
    }
  )
}

/**
 * GET sng/hands/:handId
 */
export const getSngHandHistoryService = (handId) => {
  return axiosInstanceService(METHOD_TYPES.get, `sng/hands/${handId}`, {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}
